<template>
  <router-view />
</template>

<script>

export default {
  name: "App",
  watch: {
    '$route'(to) {
      if (to.meta && to.meta.title) {
        document.title = to.meta.title
      }
    }
  },
  mounted() {
    // 初始页面标题
    if (this.$route.meta && this.$route.meta.title) {
      document.title = this.$route.meta.title
    }
  }
};
</script>
<style>
#app {
  font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Microsoft YaHei",
    "微软雅黑", "Helvetica Neue", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  top: 0;
  left: 0;
  width: 100%;
  /*
  color: #2c3e50;*/
}

body {
  line-height: 1.75em;
  background: #f3f3f3;
}

#main {
  position: relative;
  padding: 0;
  color: #5e5e5e;
  margin: 0 auto;
  clear: both;
  height: 92vh;
}

#sidebar{
  height: 92vh;
}

#content{
  height: 92vh;
}

div.footer{
  height: 8vh;
}

div.header{
  height: 5vh;
  min-height: 53px;
}



#main h2,
#main h3,
#main h4 {
  color: #242424;
}

#content {
  overflow: auto;
  /*margin: 0 auto;min-width: 1000px;*/
  padding: 40px;
  float: right;
  background: #fff;

}

/* #content {
  margin: 0 0 0 0;
  min-width: 1000px;
  padding: 40px;
  float: left;
} */

#content select{
  text-align: left;
}

.content1 {
  padding: 20px 40px 0px 40px;
  background: #fff;
  position: relative;
  border-radius: 10px;
  box-shadow: 0 2px 8px #ccc;
  border-left: 5px solid #ccc;
  border-right: 5px solid #ccc;
  float: none;
}

.imageList {
  list-style: none;
  padding-left: 0;
}

.imageList li {
  clear: both;
}

#banner {
  background: #fff;
}

#box1 {
  /*min-width: 600px;*/
  overflow: hidden;
  margin: 0 0 35px 0;
  width: 100%;
}

#box2 {
  /*min-width: 600px;*/
  overflow: hidden;
  box-shadow: 5px;
  width: 100%;
}

#box3 {
  /*min-width: 300px;*/
  overflow: hidden;
  margin: 0 0 0 330px;
}

#chapterTitle {
  display: block;
  /*width: 600px;text-align: center;*/
  margin: 10px auto 10px auto;
  font-size: 28px;
  line-height: 1.35;
  font-weight: 700;
  color: #1a1d20;
}

#chapterContent img {
  border: 1px solid #ccc;
  border-radius: 5px;
  margin: 1em auto;
  box-shadow: 0 2px 8px #000;
  display: block;
  max-width: 100%;
  height: auto;
}

#chapterContent a {
  color: dodgerblue;
}

#main {
  top: 53px;
  position: relative;
  padding: 0;
  /*min-width: 900px;
	max-width: 1180px;*/
  color: #5e5e5e;
}

#main strong {
  color: #3e3e3e;
}

#main ul {
  list-style: none;
}

#main ul li {
  padding: 15px 0 15px 0;
}

/* Dropdown menus override the big li padding */
#main .dropdown-menu li {
  padding: 0;
}

#main ul li.first {
  padding-top: 0;
  border-top: 0;
}

#main ul.imageList li {
  padding: 15px;
  font-size: 16px;
}

#sidebar {
  /*width: 240px;*/
  z-index: 0;
  left: 0;
  border-right: 5px solid #95142a;
  overflow: auto;
}

#sidebar h3 {
  /*width: 150px;*/
  margin: 0 auto 20px auto;
  font-weight: bold;
}

#sidebar a {
  text-decoration: none;
}

#sidebar h2,
#sidebar h3,
#sidebar h4 {
  color: #fff;
}

#sidebar ul {
  list-style: none;
}

#sidebar ul li {
  border-top: dotted 1px #70665f;
  padding-bottom: 0;
  padding-top: 15px;
  padding-left: 15px;
  margin-bottom: 15px;
}

#sidebar ul li.first {
  padding-top: 0;
  border-top: 0;
}

#sidebar ul li ul {
  list-style: none;
  margin-left: 20px;
  display: none;
  padding: 0;
  margin-bottom: 0;
}

#sidebar ul li ul li {
  border: none;
  margin-top: 0px;
  margin-bottom: 0px;
}

progress {
  height: 15px;
}

.correct,
.error {
  display: block;
  height: 20px;
  width: 20px;
  background: url("assets/state.svg") no-repeat 0 -20px;
  white-space: nowrap;
  overflow: hidden;
  position: relative;
  float: left;
}

.correct {
  background-position: 0 0;
}

.footer {
  position: relative;
}

#childNodesOrQuizes .comment span {
  color: #f00;
  font-size: 15px;
}

#childNodesOrQuizes button {
  text-decoration: none;
  margin-left: 20px;
}

#childNodesOrQuizesTitle {
  background: linear-gradient(to right, #d09600, #fff);
  padding: 10px;
  font-size: 20px;
  font-weight: bold;
  width: 100%;
  height: 40px;
  font-family: "微软雅黑";
}

.chapterBref {
  padding-left: 10px;
  font-size: 14px;
  font-weight: normal;
}

.chapterIntro {
  font-size: 14px;
  font-weight: normal;
}

.quizTitle {
  font-size: 18px;
  font-weight: bold;
}

.sectionContent {
  font-size: 18px;
  font-weight: bold;
}

iframe {
  height: 500px;
}

#main .courseKeyword {
  text-decoration: none;
  color: #1495ff;
}

#main .courseKeyword:before {
  content: "";
}

.keyInfo {
  position: fixed;
  left: 5px;
  top: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 12px;
  font-family: "Courier New";
  width: 270px;
  padding: 20px;
  display: block;
  z-index: 10;
  background: #fff;
}

.bold {
  font-weight: bold;
}

.italic {
  font-style: italic;
}

#chapterContent div {
  text-indent: 2em;
}

#chapterContent a:before {
  content: "\e144 ";
  font-family: "Glyphicons Halflings";
  font-style: normal;
  font-weight: 400;
  line-height: 1;
}

#chapterContent a {
  text-decoration: none;
}

#content #line {
  position: relative;
  float: left;
  min-height: 400px;
  height: auto;
  width: 40px;
  font-family: "Courier New";
  text-align: center;
  vertical-align: middle;
  padding: 20px 0 20px 0;
  line-height: 20px;
  font-size: 16px;
  border-style: solid;
  border-color: #000;
  border-width: 2px;
  border-right-color: #fff;
  border-right-width: 1px;
  background: #c7edcc;
}

#content #collapseBranket {
  position: relative;
  float: left;
  height: 400px;
}

#codeEditor {
  min-width: 750px;
  counter-reset: section;
  width: 100%;
  min-height: 50px;
  height: auto;
  font-family: "Courier New";
  color: #000;
  background: #fff;
  /*#C7EDCC;*/
  line-height: 20px;
  font-size: 16px;
  overflow: auto;
  margin-top: 1em;
  margin-bottom: 1em;
  margin-left: auto;
  margin-right: auto;
  box-shadow: 0 2px 8px #000;
  border: 2px solid #fff;
  border-radius: 5px;
  padding: 5px 0;
  background: #f6f6f6;
}

.codeEditor,
.htmlEditor {
  /*min-width: 750px; */
  position: relative;
  counter-reset: section;
  width: 95%;
  min-height: 20px;
  min-width: 500px;
  height: auto;
  font-family: "Courier New";
  color: #000;
  background: #fff;
  /*#C7EDCC;*/
  line-height: 20px;
  font-size: 16px;
  overflow: auto;
  margin-top: 1em;
  margin-bottom: 1em;
  margin-left: auto;
  margin-right: auto;
  /*box-shadow: 0 2px 8px #000;
	border: 2px solid #fff;
	border-radius: 5px;*/
  padding: 5px 0;
  background: #f6f6f6;
  overflow: auto;
}

code {
  font-family: "Courier New";
  font-size: 16px;
  color: #000;
  padding: 0;
}

.field {
  color: #0000c0;
}

.annotations {
  color: #646464;
}

.plain {
  color: #000;
}

.keyword {
  color: #7f0055;
  font-weight: bold;
}

.pyFunction {
  color: #460f74;
  font-weight: bold;
}

.string {
  color: #2a00ff;
}

.css{
  color:#ff57bf;
}

.csskeyword{
  font-weight: bold;
  color: #7F007F;
}

.colon ~ span.css {
  color: #2a00ff;
  font-style:italic;
}

.comments,
.CStylecomments {
  color: #3f7f5f;
}

.CStylecomments:before {
  content: " * ";
}

.javaDoc,
.javaDocComments {
  color: rgb(63, 95, 191);
}

.javaDocComments:before {
  content: " * ";
}

.tag {
  color: #646464;
}

.jspTag {
  color: #bf5f3f;
}

.htmlTag {
  color: #3f7f7f;
}

.htmlAttr,
.htmlattr {
  color: rgb(127, 0, 127);
}

.codeNewLine:before {
  counter-increment: section;
  content: counter(section) ".";
  color: #ccc;

  display: inline-block;
  min-width: 5em;
  text-align: right;
  padding-right: 1.5em;
  text-indent: 0;
}

.codeNewLine:hover:before {
  color: #666;
}

.codeNewLine:hover {
  background: #eee;
}

.token.comment {
  color: rgba(0, 0, 0, 0.3);
}

.token.keyword,
.content .token.selector,
.content .token.tag {
  color: #b457ff;
}

.content .token.keyword,
.content .token.selector,
.content .token.tag {
  color: #b457ff;
}

.content .token.punctuation {
  color: #222;
}

.content .token.attr-name,
.content .token.operator,
.content .token.property {
  color: #ff4d00;
}

.content .token.attr-value {
  color: #222;
}

#formDiv {
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 10px;
}

/* Language badge on code editor divs */
.codeEditor::after,
.htmlEditor::after {
  content: attr(data-lang);
  position: absolute;
  top: 0;
  right: 0;
  padding: 1px 8px;
  font-size: 11px;
  font-family: Arial, sans-serif;
  background: #555;
  color: #fff;
  border-radius: 0 0 0 4px;
  text-transform: capitalize;
  pointer-events: none;
  z-index: 1;
}

/* 窄屏：代码块原本 min-width:500px，在 390px 视口里会被外层 overflow:hidden 裁掉右侧内容 */
/* 正文排版统一：H1（章名 28）> H2（小节 18）> H3（16）> 正文 15，字体与静态章节页一致 */
#chapterContent {
  font-size: 15px;
  line-height: 1.95;
  color: #2b2f33;
}

#chapterContent h2 {
  font-size: 18px;
  line-height: 1.6;
  font-weight: 700;
  margin: 26px 0 10px;
  padding-left: 10px;
  border-left: 3px solid #c0392b;
  text-indent: 0;
  color: #1a1d20;
}

#chapterContent h3 {
  font-size: 16px;
  line-height: 1.7;
  font-weight: 700;
  margin: 18px 0 6px;
  text-indent: 0;
  color: #1a1d20;
}

#chapterContent h4 {
  font-size: 15px;
  font-weight: 700;
  margin: 14px 0 4px;
  text-indent: 0;
}

#chapterContent p {
  font-size: 15px;
  line-height: 1.95;
  margin: 0 0 10px;
  text-indent: 2em;
}

@media (max-width: 991px) {
  .codeEditor,
  .htmlEditor,
  #codeEditor {
    min-width: 0;
    width: 100%;
    font-size: 13px;
    overflow-x: auto;
  }

  #chapterContent {
    overflow-wrap: break-word;
    word-wrap: break-word;
  }
}

/* MQL4 / MT4 代码着色（课程 35）：C 风格，与静态章节页的代码配色保持同一观感 */
.codeEditor[data-lang="mql4"]::after,
.htmlEditor[data-lang="mql4"]::after {
  content: "MQL4";
}

.mql4-directive {
  color: #7f0055;
  font-weight: 700;
}

.mql4-kw {
  color: #7f0055;
  font-weight: 700;
}

.mql4-type {
  color: #1a5fb4;
}

.mql4-fn {
  color: #0066cc;
}

.mql4-const {
  color: #9a5b00;
}

.mql4-num {
  color: #986801;
}

.mql4-str {
  color: #2a00ff;
}

.mql4-comment {
  color: #3f7f5f;
}

/* 代码块下的常驻复制按钮：移动端没有 hover，不能依赖 mouseover 注入 */
.mql4-copy-btn {
  display: inline-block;
  margin: 4px 0 14px;
  padding: 3px 12px;
  font-size: 12px;
  line-height: 1.6;
  color: #1f4e79;
  background: #eef5fc;
  border: 1px solid #b7d3ee;
  border-radius: 3px;
  cursor: pointer;
  text-indent: 0;
}

.mql4-copy-btn:hover {
  background: #dcecfb;
}

.mql4-copy-btn.is-copied {
  color: #1a7f3c;
  background: #eaf7ee;
  border-color: #9fd3ae;
}
</style>
